import { Routes } from '@angular/router';
import { HabilitationsComponent } from './habilitations.component';

export const HABILITATIONS_ROUTE_DATA = {
    menu: {
        icon: 'certificate',
        libelle: 'menu.habilitation'
    }
};

export const HABILITATIONS_ROUTES: Routes = [
    {
        path: '',
        redirectTo: 'liste',
        pathMatch: 'full',
        data: {
            role: 'OPERATEUR && HABILITATION_HABILITATION_LECTURE',
            menu: {
                icon: 'user-check',
                libelle: 'menu.habilitation'
            }
        }
    },
    { path: 'liste', component: HabilitationsComponent }
];
